import axios from 'axios';
import config from '$root/config.js';

export default axios.create({
  baseURL: config.API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});
